import { render, staticRenderFns } from "./SalesPersonChip.vue?vue&type=template&id=308cb702&scoped=true&"
import script from "./SalesPersonChip.vue?vue&type=script&lang=js&"
export * from "./SalesPersonChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308cb702",
  null
  
)

export default component.exports